import { NavigationMenu, DesktopNavigationMenu } from './js/navigationMenu.js';
import { debounce } from './js/utils.js';

const body = document.body;
let backdrop;

/**
 * Setup a mobile menu by cloning the main/desktop menu
 */
const classicMenu = document.querySelector('.wp-block-nars-classic-menu');
const classicMenuClone = classicMenu.cloneNode(true);
const mobileMenu = classicMenuClone.querySelector('.header-menu');
const innerMenu = classicMenuClone.querySelector('.header-menu__inner');
const menuToggler = classicMenuClone.querySelector('.menu-toggler');

if (mobileMenu) {
    mobileMenu.id = 'mobileMenu';
    mobileMenu.classList.replace('header-menu', 'mobile-menu');
}

if (innerMenu) {
    innerMenu.classList.replace('header-menu__inner', 'mobile-menu__body');
}

const mobileMenuHeader = document.createElement('div');
mobileMenuHeader.classList.add('mobile-menu__header');

if (menuToggler) {
    mobileMenuHeader.appendChild(menuToggler);
}

if (innerMenu) {
    mobileMenu.insertBefore(mobileMenuHeader, innerMenu);
}

document.querySelector('.site-header').insertAdjacentElement('afterend', classicMenuClone);

/**
 * Apply my base class for adding accessibility features to WordPress classic menus.
 */
window.addEventListener("load", function(){
    new DesktopNavigationMenu('.header-menu');
    new NavigationMenu('.mobile-menu');
});

/**
 * Event listeners
 */

// Toggle menu on main toggle button click
document.querySelectorAll(".menu-toggler").forEach((btn) =>
    btn.addEventListener("click", toggleMobileMenu)
);

// Close menu on close button click inside the mobile menu
document.querySelectorAll(".menu-close").forEach((btn) =>
    btn.addEventListener("click", hideMobileMenu)
);

// Close menu on Esc key press
document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && body.classList.contains("mobile-menu-open")) {
        hideMobileMenu();
    }
});

// Close menu on Window resize
window.addEventListener('resize', debounce(() => {
    if (body.classList.contains("mobile-menu-open")) {
        hideMobileMenu();
    }
}, 300));

/**
 * Functions
 */

// Toggle menu visibility
function toggleMobileMenu() {
    body.classList.contains("mobile-menu-open")
        ? hideMobileMenu()
        : showMobileMenu();
}

// Show menu and create backdrop
function showMobileMenu() {
    createBackdrop();
    mobileMenu.style.visibility = "visible";
    mobileMenu.setAttribute("aria-hidden", "false");
    body.classList.add("mobile-menu-open");

    // Add show classes after a slight delay
    setTimeout(() => {
        backdrop.classList.add("show");
        mobileMenu.classList.add("show");
    }, 10);
}

// Hide menu and remove backdrop
function hideMobileMenu() {
    if (backdrop) backdrop.classList.remove("show");
    mobileMenu.classList.remove("show");
    mobileMenu.setAttribute("aria-hidden", "true");

    // Wait for transitions to complete
    mobileMenu.addEventListener("transitionend", onMenuTransitionEnd, {
        once: true
    });
    backdrop.addEventListener("transitionend", onBackdropTransitionEnd, {
        once: true
    });
}

// Helper: Create backdrop
function createBackdrop() {
    backdrop = document.createElement("div");
    backdrop.classList.add("menu-backdrop");
    backdrop.addEventListener("click", hideMobileMenu);
    mobileMenu.insertAdjacentElement('afterend', backdrop);
}

// Helper: Backdrop transition end
function onBackdropTransitionEnd() {
    if (backdrop && !backdrop.classList.contains("show")) {
        backdrop.remove();
        backdrop = null;
    }
}

// Helper: Menu transition end
function onMenuTransitionEnd() {
    if (mobileMenu && !mobileMenu.classList.contains("show")) {
        mobileMenu.style.visibility = "hidden";
        body.classList.remove("mobile-menu-open");
    }
}